'use client'

import { Divider, Cell, Text, Label, Image, Badge } from '@vinted/web-ui'

import { SeparatedList } from '@marketplace-web/shared/ui-helpers'
import { useTranslate } from '@marketplace-web/shared/i18n'
import { useTracking } from '@marketplace-web/shared/event-tracker'
import { CatalogNavigationModel, CatalogAttribute } from '@marketplace-web/domain/catalog-data'

import { selectCatalogEvent } from '_libs/common/event-tracker/events'

type Props = {
  categories: Array<CatalogNavigationModel>
}

const CategoriesSection = ({ categories }: Props) => {
  const translate = useTranslate('header.side_bar')
  const { track } = useTracking()

  const handleTitleClick =
    ({ id }: CatalogNavigationModel) =>
    () => {
      const trakingEvent = selectCatalogEvent({
        catalogIds: [id],
        attributeId: CatalogAttribute.Navigation,
      })

      track(trakingEvent)
    }

  const renderCategoriesItem = (item: CatalogNavigationModel) => (
    <Cell
      key={item.id}
      type={Cell.Type.Navigating}
      prefix={
        <Image src={item.photo?.url} scaling={Image.Scaling.Cover} size={Image.Size.Regular} />
      }
      suffix={
        item.badge && <Badge theme={item.badge.theme || 'primary'} content={item.badge.title} />
      }
      body={
        <Text as="span" truncate>
          {item.title}
        </Text>
      }
      url={item.customUrl || item.url}
      urlProps={{ title: item.title }}
      onClick={handleTitleClick(item)}
      testId={`sidebar-category-item-${item.id}`}
      aria={{ 'aria-label': item.title }}
    />
  )

  return (
    <>
      <Label styling={Label.Styling.Wide} text={translate('categories')} />
      <SeparatedList separator={<Divider />}>{categories.map(renderCategoriesItem)}</SeparatedList>
    </>
  )
}

export default CategoriesSection
